import React from 'react';
import PropTypes from 'prop-types';
import Button from '@material-ui/core/Button';

import useStyles from './styles';

const FilterApplyButton = (props) => {
  const classes = useStyles();
  const {
    label, setFilters, hasDiff,
  } = props;

  return (
    <Button
      data-test="apply-filters-button"
      className={classes.filterApplyButton}
      disabled={!hasDiff}
      onClick={setFilters}
    >
      {label}
    </Button>
  );
};

FilterApplyButton.defaultProps = {
  hasDiff: false,
  setFilters: () => {},
};

FilterApplyButton.propTypes = {
  label: PropTypes.string.isRequired,
  setFilters: PropTypes.func,
  hasDiff: PropTypes.bool,
};

export default FilterApplyButton;
